var exports = {
  "az": "Box__Vpifis",
  "hE": "Title__Iqcbdk",
  "P_": "SanitizedHtml__7LwQ2K",
  "Zp": "AggregateLabels__jcAiBx",
};

module.exports = exports;
